const productPattern = new RegExp('^p-\\d+$');

export const masterUrl = (url: string): string =>
  url
    .split('/')
    .filter((string) => !productPattern.test(string))
    .join('/');

export const variantIdFromUrl = (url: string): string => {
  return url
    .split('/')
    .filter((string) => productPattern.test(string))
    .join('')
    .replace(/p-/g, '');
};
